(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cotizacion"]) return;
  try {
    
  class CotizacionForm extends HTMLElement {
    // Webhook que recibe la solicitud de cotización (Google Apps Script).
    #ENDPOINT_URL = 'https://script.google.com/macros/s/AKfycbyAbbxpHfk3NkaQrAVF2D1sMW-cEkmnrGL7UxKQ7csyXvEJeyBL9raKJ648_4f_C-JfKQ/exec';
    #ENDPOINT_SECRET = '1o-oqX8OqcoYQ9n1kVK5wiZOBM4s_E_qhGmnUjhADmE';

    connectedCallback() {
      this.cartContainer = this.querySelector('[data-cotizacion-cart]');
      this.form = this.querySelector('[data-cotizacion-form]');
      this.submitButton = this.form.querySelector('[type="submit"]');
      this.confirmation = this.querySelector('[data-cotizacion-confirmation]');
      this.cart = null;

      this.form.addEventListener('submit', this.#handleSubmit.bind(this));
      this.#loadCart();
    }

    async #loadCart() {
      try {
        const response = await fetch(`${window.theme.routes.cart}.js`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        this.cart = await response.json();
        this.#renderCart();
        this.#prefillForm();
      } catch (error) {
        console.error('Cotización BAU: error al cargar el carrito', error);
        this.#renderCartError();
      }
    }

    #renderCart() {
      const items = this.cart.items || [];

      if (!items.length) {
        this.cartContainer.innerHTML = '<p class="cotizacion__cart-empty">Tu carrito está vacío.</p>';
        return;
      }

      const rows = items.map((item) => this.#renderItem(item)).join('');
      const total = items.reduce((sum, item) => sum + (item.quantity * item.price), 0);

      this.cartContainer.innerHTML = `
        <h2 class="cotizacion__cart-heading">Tu carrito</h2>
        <ul class="cotizacion__items" role="list">${rows}</ul>
        <p class="cotizacion__cart-total">Total: ${this.#formatMoney(total)}</p>
      `;
    }

    #renderItem(item) {
      const image = item.image
        ? `<img class="cotizacion__item-image" src="${this.#imageUrl(item.image)}" alt="${this.#escape(item.title)}" width="80" height="80" loading="lazy">`
        : '<span class="cotizacion__item-image--placeholder" aria-hidden="true"></span>';
      const lineSubtotal = item.quantity * item.price;

      return `
        <li class="cotizacion__item">
          ${image}
          <div class="cotizacion__item-body">
            <p class="cotizacion__item-title">${this.#escape(item.title)}</p>
            ${item.sku ? `<p class="cotizacion__item-sku">SKU: ${this.#escape(item.sku)}</p>` : ''}
            <p class="cotizacion__item-meta">
              <span>Cantidad: ${item.quantity}</span>
              <span>${this.#formatMoney(item.price)} c/u</span>
            </p>
            <p class="cotizacion__item-subtotal">Subtotal: ${this.#formatMoney(lineSubtotal)}</p>
          </div>
        </li>
      `;
    }

    #renderCartError() {
      this.cartContainer.innerHTML = '<p class="cotizacion__cart-error" role="alert">No pudimos cargar tu carrito. Intenta recargar la página.</p>';
    }

    #prefillForm() {
      const attrs = (this.cart && this.cart.attributes) || {};
      const fieldsByAttribute = {
        nombre: attrs.cliente_nombre,
        email: attrs.cliente_email,
        telefono: attrs.cliente_telefono,
        empresa: attrs.cliente_empresa
      };

      for (const [field, value] of Object.entries(fieldsByAttribute)) {
        if (!value) continue;
        const input = this.form.elements.namedItem(field);
        if (input) input.value = value;
      }
    }

    async #handleSubmit(event) {
      event.preventDefault();
      if (!this.form.reportValidity()) return;

      const formData = new FormData(this.form);
      const attrs = (this.cart && this.cart.attributes) || {};
      const items = (this.cart && this.cart.items) || [];

      const payload = {
        origen: attrs.origen || 'shopify',
        dealId: attrs.dealId || null,
        cliente: {
          nombre: formData.get('nombre') || '',
          email: formData.get('email') || '',
          telefono: formData.get('telefono') || '',
          empresa: formData.get('empresa') || '',
          notas: formData.get('notas') || ''
        },
        carrito: items.map((item) => ({
          sku: item.sku || null,
          nombre: item.title,
          cantidad: item.quantity,
          precio_unitario: item.price / 100,
          foto: item.image ? this.#imageUrl(item.image) : null
        })),
        secret: this.#ENDPOINT_SECRET
      };

      this.submitButton.disabled = true;

      try {
        // Content-Type text/plain evita el preflight CORS que Apps Script no
        // responde bien; el backend igual parsea el body como JSON.
        const response = await fetch(this.#ENDPOINT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        this.#showMessage('Solicitud recibida, te contactaremos pronto.', false);
        this.#clearCart();
      } catch (error) {
        console.error('Cotización BAU: error al enviar la solicitud', error);
        this.#showMessage('No pudimos enviar tu solicitud. Por favor, intenta nuevamente.', true);
      } finally {
        this.submitButton.disabled = false;
      }
    }

    async #clearCart() {
      try {
        const response = await fetch(`${window.theme.routes.cart}/clear.js`, { method: 'POST' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
      } catch (error) {
        console.error('Cotización BAU: error al limpiar el carrito', error);
      }
    }

    #showMessage(text, isError) {
      this.confirmation.className = isError
        ? 'cotizacion__confirmation errors'
        : 'cotizacion__confirmation note form-success';
      this.confirmation.setAttribute('role', isError ? 'alert' : 'status');
      this.confirmation.hidden = false;
      this.confirmation.textContent = '';
      requestAnimationFrame(() => {
        this.confirmation.textContent = text;
      });

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.confirmation.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
    }

    #imageUrl(url) {
      return url.startsWith('//') ? `https:${url}` : url;
    }

    #escape(value) {
      const div = document.createElement('div');
      div.textContent = value ?? '';
      return div.innerHTML;
    }

    #formatMoney(cents) {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(cents / 100);
    }
  }

  customElements.define('cotizacion-form', CotizacionForm);

  } catch(e) { console.error(e); }
})();
})();
